import React from "react";

const Location = ({ color = "#1E84BE" }) => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9994 3.66699C14.9044 3.66699 9.16602 9.40533 9.16602 16.5003C9.16602 26.1253 21.9994 40.3337 21.9994 40.3337C21.9994 40.3337 34.8327 26.1253 34.8327 16.5003C34.8327 9.40533 29.0944 3.66699 21.9994 3.66699ZM12.8327 16.5003C12.8327 11.4403 16.9394 7.33366 21.9994 7.33366C27.0594 7.33366 31.166 11.4403 31.166 16.5003C31.166 21.7803 25.886 29.682 21.9994 34.6137C18.186 29.7187 12.8327 21.7253 12.8327 16.5003Z"
        fill={color}
      />
      <path
        d="M21.9993 21.0837C24.5307 21.0837 26.5827 19.0316 26.5827 16.5003C26.5827 13.969 24.5307 11.917 21.9993 11.917C19.468 11.917 17.416 13.969 17.416 16.5003C17.416 19.0316 19.468 21.0837 21.9993 21.0837Z"
        fill={color}
      />
    </svg>
  );
};

export default Location;
